import axios from "axios";
import { getApiOrigin } from "./apiOrigin";

const STORAGE_KEY = "giftygen_app_region";

axios.defaults.baseURL = getApiOrigin();

export function getAppRegion() {
  if (typeof window === "undefined") return "IN";
  const v = window.localStorage.getItem(STORAGE_KEY);
  if (v === "US" || v === "IN") return v;
  return "IN";
}

/** Persist API region (India vs USA) so all axios calls use the matching database. */
export function setAppRegion(region) {
  if (typeof window === "undefined") return;
  const r = region === "US" ? "US" : "IN";
  window.localStorage.setItem(STORAGE_KEY, r);
}

axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  const headers = config.headers || {};
  headers["X-App-Region"] = getAppRegion();
  config.headers = headers;
  return config;
});

// Align API region before first request: manual country choice beats cached geolocation.
if (typeof window !== "undefined") {
  try {
    const choice = window.localStorage.getItem("giftygen_country_choice");
    if (choice === "IN" || choice === "US") {
      setAppRegion(choice);
    } else {
      const raw = window.localStorage.getItem("giftygen_user_location");
      if (raw && !window.localStorage.getItem(STORAGE_KEY)) {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed.country === "string") {
          setAppRegion(parsed.country === "IN" ? "IN" : "US");
        }
      }
    }
  } catch (_) {
    /* ignore */
  }
}

export default axios;
